import * as TYPES from './constants';
import {
  requestReportObjects,
  receiveReportObjects,
  handleReportObjectsError,
} from './actions';

import {API, JSON_HEADER, JWT_HEADER} from 'config/srm.config';

const initialState = {
  data: null,
  request: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_REPORT_OBJECTS:
      return {
        ...state,
        request: true,
      };
    case TYPES.RECEIVE_REPORT_OBJECTS:
      return {
        ...state,
        data: action.payload,
        request: false,
        error: false,
      };
    case TYPES.REPORT_OBJECTS_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    default:
      return state;
  }
};

export const fetchReportObjects = () => (dispatch, getState) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  const config = {
    method: 'GET',
    mode: 'cors',
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
    cache: 'default',
  };
  dispatch(requestReportObjects());
  try {
    return fetch(`${API.reports.report_objects}`, config)
      .then(response => response.json())
      .then(json => {
        dispatch(receiveReportObjects(json));
      })
      .catch(err => {
        console.log(err);
        dispatch(handleReportObjectsError(err));
      });
  } catch (err) {
    console.log(err);
    dispatch(handleReportObjectsError(err));
  }
};
